<a *ngIf="forMenu" mat-menu-item aria-label="Toggle dark or light mode" (click)="toggleTheme()">
    <mat-icon>
        {{ themeService.currentTheme.value == 'dark' ? 'light_mode' : 'dark_mode'}}
    </mat-icon> 
    {{ themeService.currentTheme.value == 'dark' ? 'Light Mode' : 'Dark Mode'}}
</a>
<button *ngIf="!forMenu" mat-icon-button aria-label="Toggle dark or light mode" (click)="toggleTheme()">
    <mat-icon>{{ themeService.currentTheme.value == 'dark' ? 'light_mode' : 'dark_mode'}}</mat-icon>
</button>